// extracted by mini-css-extract-plugin
module.exports = {"modal":"AccountProfileModal_modal__1bUqI","body":"AccountProfileModal_body__tig7K"};